import './index.scss';
import {Typography} from '@customink/pigment-react';
import React, {useEffect, useRef, useState} from 'react';
import usePriceQuote from '../../hooks/queries/quotes';

const calculateBuyMoreSaveMoreQuantity = (
  discountPercentage,
  canOrderSingles,
  minQty,
  defaultQty,
  quoteQuantity
) => {
  if (discountPercentage < 5) {
    if (defaultQty > minQty) {
      return defaultQty;
    }
    if (defaultQty <= quoteQuantity) {
      return Math.ceil((quoteQuantity * 2) / 10) * 10;
    }
    if (canOrderSingles < 3) {
      return 5;
    }
    if (minQty >= 3 && canOrderSingles < 6) {
      return 10;
    }
    return canOrderSingles * 2;
  }
  return null;
};

export default function DiscountMessage({
  canOrderSingles,
  currentColor,
  discountPercentage,
  minQty,
  defaultQty,
  quoteQuantity
}) {
  const [buyMoreSaveMoreQuantity, setBuyMoreSaveMoreQuantity] = useState(0);
  const {data: buyMoreSaveMore} = usePriceQuote(
    currentColor?.legacyColorId,
    buyMoreSaveMoreQuantity,
    1,
    0,
    true
  );
  const getBuyMoreSaveMore = buyMoreSaveMore && Object.values(buyMoreSaveMore);
  const getBuyMoreSaveMoreRef = useRef(getBuyMoreSaveMore);
  useEffect(() => {
    setBuyMoreSaveMoreQuantity(
      calculateBuyMoreSaveMoreQuantity(
        discountPercentage,
        canOrderSingles,
        minQty,
        defaultQty,
        quoteQuantity
      )
    );
  }, [
    discountPercentage,
    minQty,
    canOrderSingles,
    calculateBuyMoreSaveMoreQuantity,
    setBuyMoreSaveMoreQuantity,
    defaultQty,
    quoteQuantity
  ]);

  useEffect(() => {
    if (getBuyMoreSaveMore) {
      getBuyMoreSaveMoreRef.current = getBuyMoreSaveMore;
    }
  }, [getBuyMoreSaveMore]);
  return (
    <>
      <Typography className="pc-Discount-Message">
        Buy more, save more!
      </Typography>
      <Typography className="pc-Discount-Message pc-Discount-Message-pricing">
        Order {buyMoreSaveMoreQuantity} items and pay only $
        {!getBuyMoreSaveMore
          ? getBuyMoreSaveMoreRef.current
          : getBuyMoreSaveMore}{' '}
        each.
      </Typography>
    </>
  );
}
